var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pillMenuItem p-2 w-full flex flex-row items-center",on:{"click":function($event){return _vm.$emit('click', _vm.route)}}},[_c('span',{staticClass:"text-base lg:text-lg px-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }